
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-203aa86a&scoped=true!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OldFooter.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./OldFooter.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-203aa86a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./OldFooter.vue"),
  /* scopeId */
  "data-v-203aa86a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/OldFooter.vue
// module id = 938
// module chunks = 40